import React from 'react';
import { PostPerson } from './PostPerson';
import { PostBubble } from './PostBubble';
import { PostUpdateForm } from '../forms/PostUpdateForm';
import { PostReply, PostTypes } from '../Post.types';
import IForm from '../../../../types/IForm';

type PostBody = {
  post: PostReply;
  editEditorId: string;
  type: PostTypes;
  hash: string;
  headingHierarchy: number;
  currentForm?: IForm;
};

/**
 * Displaying User Information and the content.
 *
 * If the
 */
export function PostBody({ editEditorId, type, currentForm, hash, headingHierarchy, post }: PostBody) {
  const editorIsOpen = hash?.includes(editEditorId);
  const currentOpenFormIsUpdate = currentForm && currentForm === post?.updateForm;
  const editFormIsOpen = editorIsOpen && currentOpenFormIsUpdate;

  return (
    <div className="posts__body">
      {!editFormIsOpen && (
        <>
          <PostPerson model={post} />
          <PostBubble model={post} />
        </>
      )}
      <div className="posts__skip-to-editor" id={editEditorId} key={editEditorId}>
        <div className="posts__skip-to-editor-content">
          {editFormIsOpen && (
            <PostUpdateForm type={type} currentForm={currentForm} post={post} headingHierarchy={headingHierarchy} />
          )}
        </div>
      </div>
    </div>
  );
}
